<template>
  <div>
    <add-new-data-sidebar
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="addNewDataSidebar = false"
      :form="formSideBar"
      :title="titleSideBar"
      :dados="dadosSideBar"
      @concluido="concluded"
    />

    <vx-card v-if="!showRegisterBrandModelPage">
      <div id="data-list-list-view" class="data-list-container">
        <!------------ START TABELA LIST FECHAMENTO------------>
        <vs-table
          noDataText="Nenhuma Regra Encontrada"
          class="tablePrincipal"
          ref="table"
          multiple
          v-model="selected"
          pagination
          :max-items="itemsPerPage"
          :data="itens"
        >
          <div
            slot="header"
            class="flex flex-grow justify-between"
          >
              <!------------ START  MENU DE AÇÕES ------------>
              <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
                <div
                  class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32"
                >
                  <span class="mr-2">Ações</span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <vs-dropdown-menu>
                  <vs-dropdown-item
                    @click="handleAction(false)"
                    v-if="$can($actionsDefault.Escrita, subjectPermission)"
                  >
                    <span>Inativar</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    @click="handleAction(true)"
                    v-if="$can($actionsDefault.Escrita, subjectPermission)"
                  >
                    <span>Reativar</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
              <!------------ END MENU DE AÇÕES ------------>
               <!------------ START ITENS POR PÁGINA -->
            <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
              <div
                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
              >
                <span class="mr-2"
                  >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
                  {{
                    itens.length - currentPage * itemsPerPage > 0
                      ? currentPage * itemsPerPage
                      : itens.length
                  }}
                  de {{ itens.length }}</span
                >
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>

              <vs-dropdown-menu>
                <vs-dropdown-item @click="itemsPerPage = 5">
                  <span>5</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage = 10">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage = 25">
                  <span>25</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage = 50">
                  <span>50</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
            <!------------ END ITENS POR PÁGINA -->
            
          </div>
          <!------------ START TITULO DA TABELA ------------>
          <template slot="thead">
            <vs-th sort-key="nome">Nome</vs-th>
            <vs-th sort-key="exigencia">Exigência %</vs-th>
            <vs-th>Status</vs-th>
            <vs-th>Ações</vs-th>
          </template>
          <!------------ END TITULO DA TABELA ------------>
          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td class="w-1/4">
                  <p class="product-category">{{ tr.name }}</p></vs-td
                >
                <vs-td class="w-1/4">
                  <p class="product-category">{{ tr.requirement }}</p></vs-td
                >
                <vs-td class="w-1/4">
                  <vs-chip
                    :color="getColorByDeletedat(tr.deleted_at)"
                    class="product-order-status"
                    >{{ getStatusByDeletedat(tr.deleted_at) }}</vs-chip
                  >
                </vs-td>
                <vs-td class="w-1/4">
                  <div class="flex flex-row gap-4">
                    <vs-button
                      v-if="writePermission"
                      radius
                      v-tooltip="'Editar'"
                      color="success"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-edit"
                      class="d-inline"
                      @click="openSiderBar(tr, indextr)"
                    ></vs-button>
                    <vs-button
                      v-if="writePermission && tr.name === 'Renovação Emendada'"
                      radius
                      v-tooltip="'Abrir Modal Cadastro Seguradoras'"
                      color="primary"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-plus"
                      class="d-inline"
                      @click="openModalCadastroSeguradoras(tr, indextr)"
                    ></vs-button>
                    <vs-button
                      v-if="writePermission && tr.name === '0KM'"
                      radius
                      v-tooltip="'Abrir modal dias desde a saída da concessionaria'"
                      color="primary"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-plus"
                      class="d-inline"
                      @click="openDealershipExitDaysModal(tr, indextr)"
                    ></vs-button>
                    <vs-button
                      v-if="writePermission && tr.name === 'Modelo/Ano'"
                      radius
                      v-tooltip="'Cadastrar Marca/Modelos'"
                      color="primary"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-plus"
                      class="d-inline"
                      @click="handleRegisterBrandModelPage(tr, indextr)"
                    ></vs-button>
                  </div>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
        <!------------ END TABELA ------------>
      </div>
    </vx-card>

    <ModalCadastroSeguradoras
      ref="ModalCadastroSeguradoras"
      @close="updateRegistrations"
    />

    <DealershipExitDaysModal
      ref="DealershipExitDaysModal"
      :active="showDealershipExitDaysModal"
      :registrations="dealershipExitDaysModalRegistrations"
      @save="updateRegistrations"
      @close="closeDealershipExitDaysModal"
    />

    <ListVistoriaPreviaMarcaModeloAno
      v-if="showRegisterBrandModelPage"
      :registrations="registrations"
      @register="updateRegistrations"
      @goBack="showRegisterBrandModelPage = false"
    />
  </div>
</template>
<script>
import utilsList from '../../../utils/list/index';
import notify from '../../../utils/notify';
import services from '../../../services/life-api';

import ModalCadastroSeguradoras from '../../modais/ModalCadastroSeguradoras.vue';
import ListVistoriaPreviaMarcaModeloAno from './components/List-vistoria-previa-marca-modelo.ano.vue';
import AddNewDataSidebar from '../../Includes/SideBar.vue';
import DealershipExitDaysModal from "../../modais/DealershipExitDaysModal.vue";

export default {
  name: 'vistoria-previa',
  components: {
    ModalCadastroSeguradoras,
    ListVistoriaPreviaMarcaModeloAno,
    AddNewDataSidebar,
    DealershipExitDaysModal,
  },
  data() {
    return {
      subjectPermission: 'Vistoria Prévia',
      controller: 'prior-inspections',
      getColorByDeletedat: utilsList.getColorAtivoInativoByDeletedAt,
      getStatusByDeletedat: utilsList.getAtivoInativoByDeletedAt,
      itemsPerPage: 5,
      currentPage: 1,
      selected: [],
      itens: [],
      index: 0,
      registrations: '',
      showRegisterBrandModelPage: false,
      titleSideBar: 'Editar Regra',
      formSideBar: 'VistoriaPrevia',
      addNewDataSidebar: false,
      dadosSideBar: {},
      dealershipExitDaysModalRegistrations: null,
      showDealershipExitDaysModal: false,
    };
  },
  created() {
    this.getRules();
  },
  computed: {
    writePermission() {
      return this.$can(this.$actionsDefault.Escrita, this.subjectPermission);
    },
  },
  methods: {
    async getRules() {
      try {
        this.$vs.loading();
        const { data } = await services.getAll(this.controller);
        this.itens = data;
      } catch (error) {
        notify.notifyFail(this.$vs, error.response.data.message);
      } finally {
        this.$vs.loading.close();
      }
    },
    openSiderBar(item){
      this.dadosSideBar = item;
      this.addNewDataSidebar = true;
    },
    async handleAction(status) {
      try {
        const promises = [];
        this.$vs.loading();
        this.selected.forEach((item) => {
          promises.push(services.update(this.controller, { status }, item.id));
        });

        await Promise.all(promises);
        notify.notifySuccess(
          this.$vs,
          `${this.selected.length} registros atualizados!`,
        );

        this.selected = [];
        await this.getRules();
      } catch (error) {
        notify.notifyFail(this.$vs, error.response.data.message);
      } finally {
        this.$vs.loading.close();
      }
    },
    openModalCadastroSeguradoras(item, index) {
      this.index = index;
      this.$refs.ModalCadastroSeguradoras.open(item.registrations);
    },
    openDealershipExitDaysModal(item, index) {
      this.index = index;
      this.dealershipExitDaysModalRegistrations = item.registrations;
      this.showDealershipExitDaysModal = true;
    },
    closeDealershipExitDaysModal() {
      this.index = null;
      this.showDealershipExitDaysModal = false;
    },
    handleRegisterBrandModelPage(item, index) {
      this.index = index;
      this.registrations = item.registrations;
      this.showRegisterBrandModelPage = true;
    },
    async updateRegistrations(registrations) {
      const id = this.itens[this.index].id;
      const body = { registrations };
      await this.updateData(this.controller, id, body);
      await this.getRules();
      this.closeDealershipExitDaysModal();
    },
    async updateData(controller, id, body) {
      try {
        await services.update(controller, body, id);
        await this.getRules();
        notify.notifySuccess(this.$vs, `1 registros atualizados!`);
      } catch (error) {
        notify.notifyFail(this.$vs, error.response.data.message);
      } finally {
        this.$vs.loading.close();
      }
    },
    concluded() {
      this.getRules();
    },
  },
};
</script>
<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
